export const tags = {
    "role": [
        {
            id: 0,
            name: "CIO/CDO",
        },
        {
            id: 1,
            name: "Data Engineer",
        },
        {
            id: 2,
            name: "Business Intelligence",
        },
        {
            id: 3,
            name: "Marketing",
        },
        {
            id: 4,
            name: "Database Manager",
        }
    ],
    "industry": [
        {
            id: 0,
            name: "Financial Services",
        },
        {
            id: 1,
            name: "Healthcare",
        },
        {
            id: 2,
            name: "Retail",
        },
        {
            id: 3,
            name: "Technology",
        },
        {
            id: 4,
            name: "Logistics",
        },
    ],
    "platforms": [
        {
            id: 0,
            name:"Oracle",
        },
        {
            id: 1,
            name: "MySQL",
        },
        {
            id: 2,
            name:"Snowflake",
        },
        {
            id: 3,
            name: "Google Cloud",
        },
        {
            id: 4,
            name: "AWS",
        },
        {
            id: 5,
            name: "Microsoft Azure",
        },
        {
            id: 6,
            name: "Salesforce",
        },
        {
            id: 7,
            name: "Marketo",
        },
        {
            id: 8,
            name: "Hubspot",
        }, 
    ],
    "usecases": [
        {
            id: 0,
            name:"Data Integration",
        },
        {
            id: 1,
            name: "Real-Time Analytics",
        },
        {
            id: 2,
            name:"Tutorial",
        },
        {
            id: 3,
            name: "Explainer",
        },
        {
            id: 4,
            name: "Snowflake",
        },
        {
            id: 5,
            name: "Google Cloud",
        },
        {
            id: 6,
            name: "Microsoft Azure",
        },
        {
            id: 7,
            name: "Amazon Web Services",
        },
        {
            id: 8,
            name: "Kafka",
        },
        {
            id: 9,
            name: "Database Architects",
        },
        {
            id: 10,
            name: "Data Analysts",
        },
        {
            id: 11,
            name: "Security",
        },
        {
            id: 12,
            name: "Data Scientists",
        }
    ],
}